import { useQuery } from "react-query";
import { apiGetContractOffer } from "../../../../../api/contract/apiGetContractOffer";
import { TGetContractsItem } from "../../../../../api/contract/contract.types";
import {
  ExtractFnReturnType,
  QueryConfig,
} from "../../../../../lib/react-query";
import { contractKeys } from "../util/contract.query-keys";

export const getContractOffer = async ({
  contractId,
}: {
  contractId: string;
}): Promise<TGetContractsItem> => {
  return apiGetContractOffer(contractId);
};

type QueryFnType = typeof getContractOffer;

type TUseContractOptions = {
  contractId: string;
  config?: QueryConfig<QueryFnType>;
};

export const useContractOffer = ({
  contractId,
  config,
}: TUseContractOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: contractKeys.item(contractId),
    queryFn: () => getContractOffer({ contractId }),
  });
};
